<template>
  <div v-if="hasAudioOnTimeline" class="-toggle-wrapper">
    <span
      ref="tooltipBody"
      class="wticon"
      :class="iconClass"
      @click="toggleVOWaveform"
      v-tooltip="tooltipOptions"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import app from 'app';

export default {
  name: 'WtWaveformToggle',

  computed: {
    tooltipOptions() {
      let title;
      let description;

      if (this.enableVOWaveform) {
        title = 'waveform.on.title';
        description = 'waveform.on.description';
      } else {
        title = 'waveform.off.title';
        description = 'waveform.off.description';
      }

      return {
        animation: false,
        trigger: 'hover',
        wrapperClass: 'large',
        placement: 'top auto',
        delay: { show: 250, hide: 0 },
        title: `
          <div class="waveform-tooltip">
            <div class="-title">${app.culture.get(title)}</div>
            <div class="-description">${app.culture.get(description)}</div>
          </div>
        `.normalizeSpace(),
        html: true,
      };
    },
    iconClass() {
      return this.enableVOWaveform
        ? 'wticon-waveform-full'
        : 'wticon-waveform-empty';
    },
    ...mapState({
      enableVOWaveform: (state) => state.story.enableVOWaveform,
    }),
    ...mapGetters(['hasAudioOnTimeline']),
  },
  methods: {
    toggleVOWaveform: _.debounce(
      function () {
        this.setEnableVOWaveform(!this.enableVOWaveform);
        app.storyController.story.invalidateFullPreview();
        this.$nextTick(() => {
          if (!this._isDestroyed) {
            $(this.$refs.tooltipBody).tooltip('show');
          }
        });
      },
      app.TIME.MENTAL.λ,
      { leading: true, trailing: false }
    ),
    ...mapMutations(['setEnableVOWaveform']),
  },
};
</script>

<style lang="scss">
.waveform-tooltip {
  min-width: 160px;
}
</style>
<style lang="scss" scoped>
.-toggle-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin-right: 20px;
}

.wticon {
  cursor: pointer;
  font-size: 20px;
}
</style>
